import React from 'react';
import { Button } from '@/components/ui/button';
import { Hash, Loader2 } from 'lucide-react';
import { useHashtagGeneration } from '@/hooks/production/useHashtagGeneration';

interface HashtagGenerationButtonProps {
  question: string;
  answer: string;
  onHashtagsGenerated: (hashtags: string[]) => void;
  disabled?: boolean;
}

const HashtagGenerationButton: React.FC<HashtagGenerationButtonProps> = ({
  question,
  answer,
  onHashtagsGenerated,
  disabled = false
}) => {
  const { generateHashtags, generatingHashtags } = useHashtagGeneration();

  const handleGenerateHashtags = async () => {
    const hashtags = await generateHashtags(question, answer);
    if (hashtags.length > 0) {
      onHashtagsGenerated(hashtags);
    }
  };

  const canGenerate = question.trim() && answer.trim() && !disabled;

  return (
    <Button
      type="button"
      variant="outline"
      onClick={handleGenerateHashtags}
      disabled={!canGenerate || generatingHashtags}
      className="flex items-center gap-2"
    >
      {generatingHashtags ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Hash className="h-4 w-4" />
      )}
      {generatingHashtags ? 'Genererer...' : 'Generer hashtags'}
    </Button>
  );
};

export default HashtagGenerationButton;